import React from 'react'
import { Row, Col } from 'react-flexbox-grid'
// import Info from './../Info'

const Website = ({
  techContactName = '',
  techContactPhone = '',
  techContactEmail = '',
  websiteURL = '',
  onChange,
  children,
}) => (
  <div className="fieldset-wrap" id="group-lessons">
    <fieldset className="fieldset">
      <legend className="legend">
        6. Website<br />
        <small>Fill in the contact information for the technical admin of your website.</small>
      </legend>

      <Row className="form--row">
        <Col xs={12}>
          <div className="form-group form-group__with-info">
            <label htmlFor="techContactName">Name - Technical contact person (optional)</label><br />
            {/*
                <Info className="info__pin-right">
                    If you don't have a CMS, contact details and permission to contact the Golf Clubs/Professional website developer to drop the Golf lesson Booking Code - (5 mins of work)
                </Info>
            */}
            <input onChange={onChange} type="text" id="techContactName" name="techContactName" defaultValue={techContactName} />
          </div>
        </Col>
      </Row>

      <Row className="form--row">
        <Col xs={12}>
          <div className="form-group">
            <label htmlFor="techContactPhone">Phone - Technical contact person (optional)</label><br />
            <input onChange={onChange} type="tel" id="techContactPhone" name="techContactPhone" defaultValue={techContactPhone} />
          </div>
        </Col>
      </Row>

      <Row className="form--row">
        <Col xs={12}>
          <div className="form-group">
            <label htmlFor="techContactEmail">Email - Technical contact person (optional)</label><br />
            <input onChange={onChange} type="email" id="techContactEmail" name="techContactEmail" defaultValue={techContactEmail} />
          </div>
        </Col>
      </Row>

      <Row className="form--row">
        <Col xs={12}>
          <div className="form-group">
            <label htmlFor="websiteURL">Website</label><br />
            <input onChange={onChange} required type="text" id="websiteURL" name="websiteURL" defaultValue={websiteURL} />
          </div>
        </Col>
      </Row>
      { children }
    </fieldset>
  </div>
)

export default Website



// WEBPACK FOOTER //
// ./src/components/Website/Website.js